import React from "react";

export default function GlockOverlay({ phase }) {
  if (!phase) return null;
  return (
    <img
      src="/glockhand.png"
      alt=""
      className={`glock-hand ${phase === "rise" ? "glock-rising" : phase === "shoot" ? "glock-shooting" : phase === "lower" ? "glock-lowering" : ""}`}
      draggable={false}
    />
  );
}
